var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsSecops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secops__Property 1=Secops, State=Default",
    className: "secops__Property secops__1=Secops, secops__State=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "secops__Vector",
    fill: "currentColor",
    d: "M22.443 5.73a.647.647 0 0 0-1.038-.233L16.98 9.58l-2.103-.451-.451-2.103L18.51 2.6a.647.647 0 0 0-.233-1.037C12.896-.618 7.171 3.844 7.972 9.595c.103.741.316 1.462.632 2.14l-6.616 5.712a.465.465 0 0 0-.034.032c-1.761 1.76-.956 4.766 1.448 5.41a3.232 3.232 0 0 0 3.124-.836c.012-.012.023-.022.032-.034l5.712-6.616c5.265 2.449 11.206-1.72 10.694-7.505a7.542 7.542 0 0 0-.523-2.168h.002Zm-6.995 9.079a6.25 6.25 0 0 1-3.017-.778.647.647 0 0 0-.803.143l-6.032 6.98c-1.078 1.032-2.87.51-3.226-.94a1.94 1.94 0 0 1 .483-1.803l6.979-6.028a.647.647 0 0 0 .142-.807c-2.328-4.211.776-9.363 5.586-9.273.442.008.881.063 1.31.164l-3.622 3.929a.647.647 0 0 0-.156.574l.609 2.84a.646.646 0 0 0 .496.496l2.84.61a.646.646 0 0 0 .574-.157l3.925-3.623c.91 3.92-2.063 7.668-6.088 7.673Z",
    className: "secops__Vector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsSecops);
export default __webpack_public_path__ + "static/media/sidebar-icons-secops.6ffb36dfe866cd032ce5a2d7ac11380a.svg";
export { ForwardRef as ReactComponent };